<template>
  <div class="mt-16 px-5 md:px-10">
   <div class="xxx wow fadeIn" data-wow-delay=".3s" data-wow-duration="2s">
        <div class="Slider z-10" >
        <div class="w-full md:px-10 flex justify-center">
            <div class=" content-wrapper Slider pt-4 md:pt-20 w-full max-w-3xl items-center text-center bg-background-primaryDark flex flex-col shadow-2xl rounded-lg">
                <span class="w-full text-lg md:text-3xl lg:text-4xl font-bold text-mytext-primary p-8 pb-4">{{ $t('recentWork.slider.title') }}</span>
                <span class="w-full md:max-w-xl px-8 text-sm sm:text-xs text-center text-mytext-primary opacity-75">
                {{ $t('recentWork.slider.details') }}
                <a href="#" class="text-gradient">Github</a>
                </span>

                <div v-if="showImgFullisOpen" class="fixed inset-0 w-full h-full bg-gray-800 z-50 bg-opacity-75">
                    <div class="flex justify-end">
                        <button @click="toggleShowImgFullPathClase()" class="text-white text-5xl pr-10 focus:outline-none">
                            <i class="fa fa-remove fa-lg" />
                        </button>
                    </div>
                    <div class="flex justify-center" style="height: 80%;">
                        <div class="bg-gray-700 w-11/12 h-full">
                            <img class="w-full h-full" :src="showImgFullPath" />
                        </div>
                    </div>
                </div>

                <div id="slider1_container" class="mt-10 rounded-lg border-2 border-bdprimary" style="position: relative; width: 1000px;height: 480px; overflow: hidden;">

                    <!-- Loading Screen -->
                    <div data-u="loading" class="jssorl-009-spin" style="position:absolute;top:0px;left:0px;width:100%;height:100%;text-align:center;background-color:rgba(0,0,0,0.7);">
                        <img style="margin-top:-19px;position:relative;top:50%;width:38px;height:38px;" src="@/assets/img/1.jpg" />
                    </div>

                    <!-- Slides Container -->
                    <div data-u="slides" style="position: absolute; left: 0px; top: 0px; width: 1000px; height: 480px;">
                        <div v-for="(slide,index) in slides" :key="index">
                            <button @click="toggleShowImgFullPathOpen(slide.imgPath)" title="click to see the photo in full size">
                                <img data-u="image" class="w-full" :src="slide.imgPath" />
                            </button>
                            <img data-u="thumb" class="w-full" :src="slide.imgPath" />
                        </div>
                    </div>

                    <!-- thumbnail navigator container -->
                    <div data-u="thumbnavigator" class="jssort07" style="width: 1000px; height: 100px; left: 0px; bottom: 0px;">
                        <!-- Thumbnail Item Skin Begin -->
                        <div data-u="slides" style="cursor: default;">
                            <div data-u="prototype" class="p">
                                <div data-u="thumbnailtemplate" class="i"></div>
                                <div class="o"></div>
                            </div>
                        </div>
                        <!-- Thumbnail Item Skin End -->

                        <div data-u="arrowleft" class="jssora051" style="width:40px;height:40px;top:123px;left:8px;" data-autocenter="2" data-scale="0.75" data-scale-left="0.75">
                            <svg viewBox="0 0 16000 16000" style="position:absolute;top:0;left:0;width:100%;height:100%;">
                                <polyline class="a" points="11040,1920 4960,8000 11040,14080 "></polyline>
                            </svg>
                        </div>
                        <div data-u="arrowright" class="jssora051" style="width:40px;height:40px;top:123px;right:8px;" data-autocenter="2" data-scale="0.75" data-scale-right="0.75">
                            <svg viewBox="0 0 16000 16000" style="position:absolute;top:0;left:0;width:100%;height:100%;">
                                <polyline class="a" points="4960,1920 11040,8000 4960,14080 "></polyline>
                            </svg>
                        </div>
                        <!--#endregion Arrow Navigator Skin End -->

                    </div>
                    <!--#endregion Thumbnail Navigator Skin End -->

                </div>
                <!-- Jssor Slider End -->

            </div>
        </div>
    </div>
   </div>
</div>
</template>

<script>
  import '../assets/js/mySliderSettings.js'
  export default {
    name: 'Slider',
    data() {
        return {    
            showImgFullisOpen: false,
            showImgFullPath:null,
            slides: [
                {
                    id:1,
                    imgPath : require("@/assets/img//myWrok/gitView.jpg")
                },
                {
                    id:1,
                    imgPath : require("@/assets/img//myWrok/gitView2.jpg")
                },
                {
                    id:1,
                    imgPath : require("@/assets/img//myWrok/tailwindBuilder1.jpg")
                },
                {
                    id:1,
                    imgPath : require("@/assets/img//myWrok/tailwindBuilder2.jpg")
                },
                {
                    id:1,
                    imgPath : require("@/assets/img//myWrok/tailwindBuilder3.jpg")
                },
                {
                    id:1,
                    imgPath : require("@/assets/img//myWrok/forum.jpg")
                },
                {
                    id:1,
                    imgPath : require("@/assets/img//myWrok/forum1.jpg")
                },
                {
                    id:1,
                    imgPath : require("@/assets/img//myWrok/ecommerce1.jpg")
                },
                {
                    id:1,
                    imgPath : require("@/assets/img//myWrok/ecommerce2.jpg")
                },
                {
                    id:1,
                    imgPath : require("@/assets/img//myWrok/simpleTailwindUI.jpg")
                },
                {
                    id:1,
                    imgPath : require("@/assets/img//myWrok/tailwindComponent1.jpg")
                },
                {
                    id:1,
                    imgPath : require("@/assets/img//myWrok/tailwindComponent2.jpg")
                },
                {
                    id:1,
                    imgPath : require("@/assets/img//myWrok/tailwindComponent3.jpg")
                },
                {
                    id:1,
                    imgPath : require("@/assets/img//myWrok/tailwindComponent4.jpg")
                },
                {
                    id:1,
                    imgPath : require("@/assets/img//myWrok/tailwindComponent5.jpg")
                },
                {
                    id:1,
                    imgPath : require("@/assets/img//myWrok/tailwindComponent6.jpg")
                },
                {
                    id:1,
                    imgPath : require("@/assets/img//myWrok/tailwindComponent7.jpg")
                },
                {
                    id:1,
                    imgPath : require("@/assets/img//myWrok/wikurAlawghadGame.jpg")
                },
            ]
        }
    },
    methods: {
        toggleShowImgFullPathOpen(path){
            this.showImgFullPath = path
            this.showImgFullisOpen = true
        },
        toggleShowImgFullPathClase(){
            this.showImgFullisOpen = false
            this.showImgFullPath = null
        },
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>   
    @import '../assets/css/mySliderSettings.css';
</style>